import React, {useState, useContext, useEffect} from 'react'
import { AppContext } from './contexts/AppContext';

import MainPage from './pages/mainPage/mainPage';
import Login from './pages/login';
import { getHttpResponse, postHttpAuthResponse } from './api/helper';
import { useQueryClient } from '@tanstack/react-query';
import { clearSession } from './helper/auth';


function App() {
  const theContext = useContext(AppContext)
  const queryClient = useQueryClient();
  const [isReadingSessionStorage, setIsReadingSessionStorage] = useState(true)
  const isAuthenticated = !!(theContext.token && theContext.userId && theContext.providerId)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoginFail, setIsLoginFail] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)

  const resetAuthentication = () => {
    clearSession();
    theContext.authenticate({token: undefined, userId: undefined, providerId: undefined})
  }
  /**
   * 
   * @returns {  {userId:string, providerId:string, initialPage:string, companyId:string, token:string} | undefined }
   */
  const getQueryParamsCredentials = () =>{
    const queryString = window.location.search;
    const params = Object.fromEntries(new URLSearchParams(queryString));
    if(!params.token){
      return {}
    }
    return params
  }


  useEffect(()=>{
    if (!isAuthenticated){
      const { token, userId, providerId, companyId } = getQueryParamsCredentials();
      //If there are query params, save them in session storage
      if(token){
        sessionStorage.setItem('token', token)
        sessionStorage.setItem('userId', userId)
        sessionStorage.setItem('providerId', providerId)
        if(companyId){
          sessionStorage.setItem('companyId', companyId)
        }
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      const lcToken= token ?? sessionStorage.getItem('token')
      const lcUserId= userId ?? sessionStorage.getItem('userId')
      const lcProviderId= providerId ?? sessionStorage.getItem('providerId')
      const lcCompanyId= companyId ?? sessionStorage.getItem('companyId')
      if(lcToken && lcUserId && lcProviderId){
        theContext.authenticate({token: lcToken, userId: lcUserId, providerId:lcProviderId, companyId: lcCompanyId})
      }
    }
    setIsReadingSessionStorage(false)
  }, [])

  const authenticationRequest = async (userName, password) => {
    const body = {
      userName,
      password
    }
    try{

      const response = await postHttpAuthResponse('authentication-service/users/loginPos', body)
      if (response.data?.success){
        const {token, userId, providerId} = response.data.userInfo
        const userData =  await getHttpResponse(`/user-configuration-service/provider/${providerId}/users/${userId}`, token, userId);
        if(userData.data.vendor === false){
          setOpenAlert(true)
          return;
        }
        queryClient.setQueryData(['userInfo', userId], userData);
        sessionStorage.setItem('token', token)
        sessionStorage.setItem('userId', userId)
        sessionStorage.setItem('providerId', providerId)
        theContext.authenticate({token, userId, providerId})
      }else{
        setIsLoginFail(true)
      }
    }
    catch(error){
      setOpenAlert(true)
    }

  }

  const loginHandler = async(userName, password) => {
    setIsLoading(true)
    setIsLoginFail(false)
    await authenticationRequest(userName, password)
    setIsLoading(false)
  }

  return isReadingSessionStorage ? <div/> : isAuthenticated ? 
    <MainPage resetAuthentication={resetAuthentication}/> :
    <Login loginHandler={loginHandler} isLoading={isLoading} isLoginFail={isLoginFail} 
    openAlert={openAlert} setOpenAlert={setOpenAlert}/> 
}

export default App;
